"use client";

import { ReactNode } from "react";
import Navigation from "../shared/Navigation";
import Footer from "../shared/Footer";

interface PublicLayoutProps {
    children: ReactNode;
    onMobile?: boolean;
}

export default function PublicLayout(props: PublicLayoutProps) {
    const { children, onMobile=false } = props;

    return (
        <div className="w-full">
            {!onMobile && (
                <Navigation type="guest" />
            )}

            <main className="w-full">
                { children }
            </main>

            {!onMobile && (
                <Footer />
            )}
        </div>
    );
}